import { rankWith, uiTypeIs, LayoutProps } from '@jsonforms/core';
import {
    ResolvedJsonFormsDispatch,
    withJsonFormsLayoutProps,
} from '@jsonforms/react';
import { cloneDeep } from 'lodash';
import { TruAction, TruNavigateAction } from '../../../../../types';
import { getElements, getRule } from '../../../../../utils/DynamicForms';
import { useDynamicFormContext } from '../../../DynamicFormContext';
import './style.scss';

type Props = LayoutProps; // use correct prop type

const HorizontalFieldsActions = (props: Props) => {
    const { formData } = useDynamicFormContext();
    const elements = getElements(props.uischema).filter((element) => {
        //TODO:need to  deal with the rules on the tab itself to render the button and the tab-content based on the rule
        const rule = getRule(element);
        if (!rule) return true;

        const ruleEnum = rule.condition.schema?.enum;
        if (!ruleEnum) return true;

        // rule.effect === 'SHOW'
        const key = rule.condition.scope.split('#/properties/')?.[1];
        const values = props.data[key] as string[];

        return !!ruleEnum.find((value) => values.includes(value));
    });
    const classes = props.uischema?.options?.classes

    return (
        <div className={`tru-layout-horizontal-fields ${classes}`}>
            {elements.map((element: any, index) => {
                const updatedElement = cloneDeep(element);
                if (!formData.mustRequote) {
                    updatedElement.actions = [
                        {
                            key: "validate",
                            options: {
                                dataPath: "coverages",
                                schemaScope: "properties.coverages"
                            }
                        },
                        ...updatedElement.actions.map(
                            (a: TruAction) => {
                                if (a.key === 'navigate') {
                                    const action: TruNavigateAction = a;
                                    action.data.search = action.data.search?.replaceAll(
                                        '$quoteId',
                                        `${props.cells ? props?.cells[0] : ""}`,
                                    );
                                    return action;
                                }
                                return a;
                            },
                        )
                    ]
                }

                return (
                    <ResolvedJsonFormsDispatch
                        {...props}
                        uischema={updatedElement}
                        key={index}
                    />
                );
            })}
        </div>
    );
};

export const HorizontalFieldsActionsEntry = {
    tester: rankWith(1, uiTypeIs('HorizontalFieldsActions')),
    renderer: withJsonFormsLayoutProps(HorizontalFieldsActions),
};
